import React from 'react'
import { withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { ChangeIconButton, DeleteIconButton } from '../../../../../library/button'
import { Checkbox } from '../../../../../library/checkbox'
import { changeSingleContactListModal, setActiveContactDisplay, appendDeletionArray, subtractDeletionArray, setEditContactDisplay, setActiveContactDeletion } from '../../../../../../redux/actions/single-contact-list'
import './style.scss'

const Index = (props) => {

    const listId = props.match.params.id

	const activeCompany = useSelector(state => state.activeCompany && state.activeCompany.activeCompany)
    const deletions = useSelector(state => state.singleContactList.deletionArray)

    const selectedCompany = useSelector(state => state && state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.id)

    const dispatch = useDispatch()

	const determineSettingsHoverButton = () => {
        if(!activeCompany){
            return "Du må velge et selskap før du kan utføre denne handlingen."
        }

        if(activeCompany && !activeCompany.subscription){
            return "Du må ha et aktivt abonnement for å kunne gjøre dette."
        }
    }

	const determineSettingsDeleteButton = () => {
        if(!activeCompany){
            return "Du må velge et selskap før du kan utføre denne handlingen."
        }

        if(activeCompany && !activeCompany.subscription){
            return "Du må ha et aktivt abonnement for å kunne gjøre dette."
        }
    }

    const handleSingleSelection = (e, id) => {
        if(e.target.checked){
            if(!deletions.includes(id)){
                dispatch(appendDeletionArray(id))
            }
        } else {
            if(deletions.includes(id)){
                dispatch(subtractDeletionArray(id))
            }
        }
    }

    const selectContact = contact => {
        dispatch(setActiveContactDisplay(contact))
    }

    const clickEditContact = contact => {
        dispatch(changeSingleContactListModal({editSingleModal: true}))
        dispatch(setEditContactDisplay(contact))
    }

    const clickDeleteSingleContact = key => {
        if(activeCompany.subscription){
            dispatch(changeSingleContactListModal({deleteSingleModal: true}))
            dispatch(setActiveContactDeletion({id: key, listId: listId}))
        }
    }


	return(
		<tr className={`single-company-listing`}>
            <td><Checkbox key={props.contact.id} contactListId={props.contact.id} name="contactListId" onChange={(e) => handleSingleSelection(e, props.contact.id)} checked={deletions.includes(props.contact.id) ? true:false} type="checkbox" id="select"/></td>
			<td onClick={() => selectContact(props.contact)}><span className="name">{props.contact && props.contact.general && props.contact.general.firstName ? props.contact.general.firstName:"Ikke tilgjengelig"}</span></td>
			<td onClick={() => selectContact(props.contact)}><span className="name">{props.contact && props.contact.general && props.contact.general.lastName ? props.contact.general.lastName:"Ikke tilgjengelig"}</span></td>
			<td onClick={() => selectContact(props.contact)}>{props.contact && props.contact.contact && props.contact.contact.phone ? props.contact.contact.phone:"Ikke tilgjengelig"}</td>
			<td onClick={() => selectContact(props.contact)}>{props.contact && props.contact.contact && props.contact.contact.email ? props.contact.contact.email:"Ikke tilgjengelig"}</td>
            <td><ChangeIconButton onClick={() => clickEditContact(props.contact)} data-tip={determineSettingsHoverButton()}/><DeleteIconButton onClick={() => clickDeleteSingleContact(props.contact.id)} data-tip={determineSettingsDeleteButton()}/></td>
		</tr>
	)
}

export default withRouter(Index)